import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../config/config";

export default function CustomerDashboard({ lang = {} }) {
  const [report, setReport] = useState(null);
  const [recentContracts, setRecentContracts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const session = JSON.parse(sessionStorage.getItem("aman-customer") || "{}");
    const token = session.token;

    if (!token) return;

    const headers = { Authorization: `Bearer ${token}` };

    axios
      .get(`${apiKey}/customer-panel/reports`, { headers })
      .then((res) => {
        setReport(res.data.report);
      })
      .catch((err) => console.error(err));

    axios
      .get(`${apiKey}/customer-panel/contracts`, { headers })
      .then((res) => {
        setRecentContracts(res.data.contracts || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="container-fluid px-4 py-3">
      <div className="pagetitle mb-4">
        <h1 className="fw-bold">{lang.Dashboard || "Customer Dashboard"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">Home</li>
            <li className="breadcrumb-item active">Dashboard</li>
          </ol>
        </nav>
      </div>

      {/* Summary Cards */}
      <div className="row g-3 mb-4">
        <div className="col-md-3">
          <div className="card shadow-sm border rounded-3 p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className="text-muted small fw-bold">TOTAL CONTRACTS</span>
                <h3 className="fw-bold text-primary mb-0 mt-1">
                  {report?.total_contracts || 0}
                </h3>
              </div>
              <div className="bg-light p-3 rounded-circle text-primary">
                <i className="fa fa-file-contract fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card shadow-sm border rounded-3 p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className="text-muted small fw-bold">TOTAL VALUE (SAR)</span>
                <h3 className="fw-bold text-primary mb-0 mt-1">
                  {report?.total_borrowed ? Number(report.total_borrowed).toLocaleString() : 0}
                </h3>
              </div>
              <div className="bg-light p-3 rounded-circle text-primary">
                <i className="fa fa-sack-dollar fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card shadow-sm border rounded-3 p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className="text-muted small fw-bold">TOTAL PAID (SAR)</span>
                <h3 className="fw-bold text-primary mb-0 mt-1">
                  {report?.total_paid ? Number(report.total_paid).toLocaleString() : 0}
                </h3>
              </div>
              <div className="bg-light p-3 rounded-circle text-primary">
                <i className="fa fa-circle-check fs-4"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-3">
          <div className="card shadow-sm border rounded-3 p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className="text-muted small fw-bold">REMAINING (SAR)</span>
                <h3 className="fw-bold text-primary mb-0 mt-1">
                  {report?.remaining_balance ? Number(report.remaining_balance).toLocaleString() : 0}
                </h3>
              </div>
              <div className="bg-light p-3 rounded-circle text-primary">
                <i className="fa fa-clock fs-4"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Action Banner */}
      <div className="card shadow-sm border-0 rounded-3 mb-4 bg-primary text-white p-4">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
          <div>
            <h4 className="fw-bold mb-1">Need a New Installment Contract?</h4>
            <p className="mb-0 text-white-50">
              Apply directly to any registered branch and track your approval status in real-time.
            </p>
          </div>
          <Link to="/customer-panel/apply-contract" className="btn btn-light text-primary fw-bold px-4 py-2 mt-3 mt-md-0 shadow-sm">
            <i className="fa fa-paper-plane me-2"></i> Apply Now
          </Link>
        </div>
      </div>

      {/* Recent Contracts Table */}
      <div className="card shadow-sm border-0 rounded-3">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center">
          <h5 className="fw-bold m-0 text-dark">Recent Contracts</h5>
          <Link to="/customer-panel/contracts" className="btn btn-sm btn-outline-primary fw-bold">
            View All
          </Link>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>Contract ID</th>
                  <th>Branch</th>
                  <th>Total Value</th>
                  <th>Total Paid</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6" className="text-center py-4">Loading contracts...</td>
                  </tr>
                ) : recentContracts.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center py-4 text-muted">No contracts found.</td>
                  </tr>
                ) : (
                  recentContracts.slice(0, 5).map((item) => (
                    <tr key={item.id}>
                      <td className="fw-bold">#{item.id}</td>
                      <td>{item.branch_name || "Branch"}</td>
                      <td className="fw-bold">SAR {Number(item.total_value).toLocaleString()}</td>
                      <td className="text-success fw-bold">SAR {Number(item.total_paid || 0).toLocaleString()}</td>
                      <td>
                        <span className={`badge ${item.status === 1 ? "bg-success" : item.status === 2 ? "bg-primary" : "bg-secondary"}`}>
                          {item.status === 1 ? "Active" : item.status === 2 ? "Completed" : "Closed"}
                        </span>
                      </td>
                      <td>
                        <Link to={`/customer-panel/contracts`} className="btn btn-sm btn-light border text-primary">
                          <i className="fa fa-eye me-1"></i> Details
                        </Link>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
